import React from "react";

/**
 * "Export" / external-link arrow (vuesax linear). Inline SVG so it renders with
 * the markup — no network request, server-renderable, tree-shakeable.
 *
 * Color is inherited from the parent's CSS `color` via `stroke="currentColor"`,
 * so it auto-matches button/text color. Size via `className` (default 24px).
 */
const ExternalLinkIcon = ({
  className = "size-6",
}: {
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 11L21.2 2.80005"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9999 6.83V2H17.1699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExternalLinkIcon;
